import { capitalize } from "lodash";

import { IFilingResponse, ITrackEFilingStatus, IUserResponse } from "./interfaces";

// original formdata format for ITR1
export const ITR1FormData = {
	ITR: {
		"ITR1": {
			"CreationInfo": {
				"SWVersionNo": "1.63",
				"SWCreatedBy": "SW19001101",
				"JSONCreatedBy": "SW19001101",
				"JSONCreationDate": "2021-07-24",
				"IntermediaryCity": "Jalandhar",
				"Digest": "DfW9hW+Kv1uZD1BMnkDQy8HITd6triabaavHtb69nDA="
			},
			"Form_ITR1": {
				"FormName": "ITR-1",
				"FormVer": "Ver1.2",
				"SchemaVer": "Ver1.2",
				"AssessmentYear": "2021",
				"Description": "For Indls having Income from Salary, Pension, family pension and Interest"
			},
			"PersonalInfo": {
				"AssesseeName": {
					"FirstName": "Sourav",
					"SurNameOrOrgName": "Gupta"
				},
				"Address": {
					"ResidenceNo": "TESTING",
					"LocalityOrArea": "TESTING",
					"CityOrTownOrDistrict": "Jalandhar",
					"StateCode": "26",
					"CountryCode": "91",
					"PinCode": 144001,
					"CountryCodeMobile": 91,
					"MobileNo": 9000000000,
					"EmailAddress": "divumani95@gmail.com"
				},
				"PAN": "ABCPC9999X",
				"DOB": "1995-01-01",
				"EmployerCategory": "OTH"
			},
			"FilingStatus": {
				"ReturnFileSec": 11,
				"NewTaxRegime": "N",
				"SeventhProvisio139": "N"
			},
			"ITR1_IncomeDeductions": {
				"GrossSalary": 360000,
				"Salary": 360000,
				"PerquisitesValue": 0,
				"ProfitsInSalary": 0,
				"NetSalary": 360000,
				"DeductionUs16": 50000,
				"DeductionUs16ia": 50000,
				"EntertainmentAlw16ii": 0,
				"ProfessionalTaxUs16iii": 0,
				"IncomeFromSal": 310000,
				"GrossRentReceived": 0,
				"TaxPaidlocalAuth": 0,
				"AnnualValue": 0,
				"StandardDeduction": 0,
				"InterestPayable": 0,
				"ArrearsUnrealizedRentRcvd": 0,
				"TotalIncomeOfHP": 0,
				"IncomeOthSrc": 10000,
				"OthersInc": {
					"OthersIncDtlsOthSrc": [{ "OthSrcNatureDesc": "SAV", "OthSrcOthAmount": 10000 }]
				},
				"GrossTotIncome": 320000,
				"UsrDeductUndChapVIA": {
					"Section80C": 0,
					"Section80CCC": 0,
					"Section80CCDEmployeeOrSE": 0,
					"Section80CCD1B": 0,
					"Section80CCDEmployer": 0,
					"Section80D": 0,
					"Section80DD": 0,
					"Section80DDB": 0,
					"Section80E": 0,
					"Section80EE": 0,
					"Section80EEA": 0,
					"Section80EEB": 0,
					"Section80G": 0,
					"Section80GG": 0,
					"Section80GGA": 0,
					"Section80GGC": 0,
					"Section80U": 0,
					"Section80TTA": 10000,
					"Section80TTB": 0,
					"TotalChapVIADeductions": 10000
				},
				"DeductUndChapVIA": {
					"Section80C": 0,
					"Section80CCC": 0,
					"Section80CCDEmployeeOrSE": 0,
					"Section80CCD1B": 0,
					"Section80CCDEmployer": 0,
					"Section80D": 0,
					"Section80DD": 0,
					"Section80DDB": 0,
					"Section80E": 0,
					"Section80EE": 0,
					"Section80EEA": 0,
					"Section80EEB": 0,
					"Section80G": 0,
					"Section80GG": 0,
					"Section80GGA": 0,
					"Section80GGC": 0,
					"Section80U": 0,
					"Section80TTA": 10000,
					"Section80TTB": 0,
					"TotalChapVIADeductions": 10000
				},
				"TotalIncome": 310000
			},
			"ITR1_TaxComputation": {
				"TotalTaxPayable": 3000,
				"Rebate87A": 3000,
				"TaxPayableOnRebate": 0,
				"EducationCess": 0,
				"GrossTaxLiability": 0,
				"Section89": 0,
				"NetTaxLiability": 0,
				"TotalIntrstPay": 0,
				"IntrstPay": {
					"IntrstPayUs234A": 0,
					"IntrstPayUs234B": 0,
					"IntrstPayUs234C": 0,
					"LateFilingFee234F": 0
				},
				"TotTaxPlusIntrstPay": 0
			},
			"TaxPaid": {
				"TaxesPaid": {
					"AdvanceTax": 0,
					"TDS": 0,
					"TCS": 0,
					"SelfAssessmentTax": 0,
					"TotalTaxesPaid": 0
				},
				"BalTaxPayable": 0
			},
			"Refund": {
				"RefundDue": 0,
				"BankAccountDtls": {
					"AddtnlBankDetails": [
						{
							"UseForRefund": "true",
							"BankAccountNo": "123445",
							"IFSCCode": "HDFC0001391",
							"BankName": "HDFC BANK, VIJAY NAGAR, JALANDHAR"
						}
					]
				}
			},
			"Schedule80D": {
				"Sec80DSelfFamSrCtznHealth": {
					"SeniorCitizenFlag": "N",
					"SelfAndFamily": 0,
					"HealthInsPremSlfFam": 0,
					"PrevHlthChckUpSlfFam": 0,
					"SelfAndFamilySeniorCitizen": 0,
					"HlthInsPremSlfFamSrCtzn": 0,
					"PrevHlthChckUpSlfFamSrCtzn": 0,
					"MedicalExpSlfFamSrCtzn": 0,
					"ParentsSeniorCitizenFlag": "N",
					"Parents": 0,
					"HlthInsPremParents": 0,
					"PrevHlthChckUpParents": 0,
					"ParentsSeniorCitizen": 0,
					"HlthInsPremParentsSrCtzn": 0,
					"PrevHlthChckUpParentsSrCtzn": 0,
					"MedicalExpParentsSrCtzn": 0,
					"EligibleAmountOfDedn": 0
				}
			},
			"Verification": {
				"Declaration": {
					"AssesseeVerName": "Sourav Gupta",
					"FatherName": "RAVINDER SINGH",
					"AssesseeVerPAN": "ABCPC9999X"
				},
				"Capacity": "S",
				"Place": "Jalandhar"
			}
		}
	}
};

export const ITR1Mapping = {
	"FirstName": "ITR.ITR1.PersonalInfo.AssesseeName.FirstName",
	"MiddleName": "ITR.ITR1.PersonalInfo.AssesseeName.MiddleName",
	"SurNameOrOrgName": "ITR.ITR1.PersonalInfo.AssesseeName.SurNameOrOrgName",
	"DOB": "ITR.ITR1.PersonalInfo.DOB",
	// "FatherName": "ITR.ITR1.Verification.Declaration.FatherName",
	"MobileNo": "ITR.ITR1.PersonalInfo.Address.MobileNo",
	"EmailAddress": "ITR.ITR1.PersonalInfo.Address.EmailAddress",
	"Address.ResidenceNo": "ITR.ITR1.PersonalInfo.Address.ResidenceNo",
	"Address.ResidenceName": "ITR.ITR1.PersonalInfo.Address.ResidenceName",
	"Address.RoadOrStreet": "ITR.ITR1.PersonalInfo.Address.RoadOrStreet",
	"Address.LocalityOrArea": "ITR.ITR1.PersonalInfo.Address.LocalityOrArea",
	"Address.CityOrTownOrDistrict": "ITR.ITR1.PersonalInfo.Address.CityOrTownOrDistrict",
	"Address.StateCode": "ITR.ITR1.PersonalInfo.Address.StateCode",
	"Address.CountryCode": "ITR.ITR1.PersonalInfo.Address.CountryCode",
	"Address.PinCode": "ITR.ITR1.PersonalInfo.Address.PinCode",
	"Address.ZipCode": "ITR.ITR1.PersonalInfo.Address.ZipCode",
	"Address.CountryCodeMobile": "ITR.ITR1.PersonalInfo.Address.CountryCodeMobile",
	"PAN": "ITR.ITR1.PersonalInfo.PAN",
	"EmployerCategory": "ITR.ITR1.PersonalInfo.EmployerCategory",
	"AadhaarCardNo": "ITR.ITR1.PersonalInfo.AadhaarCardNo",
	"AadhaarEnrolmentId": "ITR.ITR1.PersonalInfo.AadhaarEnrolmentId"
};

export const ITR1FormValueDataDummy = {
	"ITR": {
		"ITR1": {
			"CreationInfo": {
				"SWVersionNo": "1.0",
				"IntermediaryCity": "Delhi",
				"SWCreatedBy": "Rohit",
				"JSONCreatedBy": "Ravindra",
				"JSONCreationDate": "2024-04-01",
				"Digest": "-.98"
			},
			"Form_ITR1": {
				"FormName": "ITR-1",
				"Description": "ITR One",
				"AssessmentYear": "2023",
				"SchemaVer": "Ver1.0",
				"FormVer": "Ver1.0"
			},
			"PersonalInfo": {
				"AssesseeName": {
					"FirstName": "Rohit",
					"MiddleName": "-",
					"SurNameOrOrgName": "Sachaan"
				},
				"Address": {
					"ResidenceNo": "987",
					"ResidenceName": "Jai Ganesh Bhavan",
					"RoadOrStreet": "Khatiwala Tank",
					"LocalityOrArea": "Near Tower Square",
					"CityOrTownOrDistrict": "Indore",
					"StateCode": "18",
					"CountryCode": "91",
					"PinCode": 452014,
					"ZipCode": "452001",
					"CountryCodeMobile": 91,
					"MobileNo": 9806782445,
					"EmailAddress": "rohit@eleopard.in"
				},
				"PAN": "EGXPT5678Y",
				"DOB": "1990-11-13",
				"EmployerCategory": "NA",
				"AadhaarCardNo": "825343216753",
				"AadhaarEnrolmentId": "5645675467832589045424345637"
			},
			"FilingStatus": {
				"ReturnFileSec": 11,
				"clauseiv7provisio139iDtls": [
					{
						"clauseiv7provisio139iNature": "1",
						"clauseiv7provisio139iAmount": 657876
					}
				],
				"NewTaxRegime": "Y",
				"SeventhProvisio139": "N",
				"IncrExpAggAmt2LkTrvFrgnCntryFlg": "Y",
				"AmtSeventhProvisio139ii": 5678768,
				"IncrExpAggAmt1LkElctrctyPrYrFlg": "Y",
				"AmtSeventhProvisio139iii": 767868,
				"clauseiv7provisio139i": "Y",
				"ReceiptNo": "782347583235769",
				"NoticeNo": "65765768",
				"OrigRetFiledDate": "2023-10-04",
				"NoticeDateUnderSec": "2023-08-20"
			},
			"PartA_139_8A": {
				"UpdatingInc": {
					"ReasonsForUpdatingIncDtls": []
				},
				"RetrntoRedCarriedFL": {
					"UDYear": {
						"UnabsorbedDepreciationYearDtls": []
					},
					"UnabsorbedDepreciation": "N"
				},
				"PAN": "EGXPT5678Y",
				"Name": "Rohit S",
				"AadhaarCardNo": "825343216753",
				"AadhaarEnrolmentId": "5645675467832589045424345637",
				"AssessmentYear": "2023",
				"PreviouslyFiledForThisAY": "Y",
				"PreviouslyFiledForThisAY_139_8A": "1",
				"Applicable_139_8A": {
					"ITRForm": "ITR1",
					"AcknowledgementNo": "768768758756545",
					"OrigRetFiledDate": "2023-07-23"
				},
				"LaidOutIn_139_8A": "N",
				"ITRFormUpdatingInc": "ITR1",
				"UpdatedReturnDuringPeriod": "1"
			},
			"ITR1_IncomeDeductions": {
				"IncomeNotified89AType": [],
				"AllwncExemptUs10": {
					"AllwncExemptUs10Dtls": [],
					"TotalAllwncExemptUs10": 3230
				},
				"IncomeFromSal": 4254,
				"TotalIncomeOfHP": 0,
				"IncomeOthSrc": 0,
				"OthersInc": {
					"OthersIncDtlsOthSrc": []
				},
				"GrossTotIncome": 0,
				"UsrDeductUndChapVIA": {
					"AnyOthSec80CCH": 0,
					"Section80C": 0,
					"Section80CCC": 0,
					"Section80CCDEmployeeOrSE": 0,
					"Section80CCD1B": 0,
					"Section80CCDEmployer": 0,
					"Section80D": 0,
					"Section80DDUsrType": "1",
					"Section80DD": 0,
					"Section80DDBUsrType": "1",
					"Section80DDB": 0,
					"Section80E": 0,
					"Section80EE": 0,
					"Section80EEA": 0,
					"Section80EEB": 0,
					"Section80G": 7890,
					"Section80GG": 0,
					"Section80GGA": 0,
					"Section80GGC": 0,
					"Section80UUsrType": "1",
					"Section80U": 0,
					"Section80TTA": 0,
					"Section80TTB": 0,
					"TotalChapVIADeductions": 0
				},
				"DeductUndChapVIA": {
					"AnyOthSec80CCH": 0,
					"Section80C": 0,
					"Section80CCC": 0,
					"Section80CCDEmployeeOrSE": 0,
					"Section80CCD1B": 0,
					"Section80CCDEmployer": 0,
					"Section80D": 0,
					"Section80DD": 0,
					"Section80DDB": 0,
					"Section80E": 0,
					"Section80EE": 0,
					"Section80EEA": 0,
					"Section80EEB": 0,
					"Section80G": 0,
					"Section80GG": 0,
					"Section80GGA": 0,
					"Section80GGC": 0,
					"Section80U": 0,
					"Section80TTA": 0,
					"Section80TTB": 0,
					"TotalChapVIADeductions": 0
				},
				"TotalIncome": 0,
				"ExemptIncAgriOthUs10": {
					"ExemptIncAgriOthUs10Dtls": [],
					"ExemptIncAgriOthUs10Total": 0
				},
				"GrossSalary": 85380,
				"Salary": 84230,
				"PerquisitesValue": 4323,
				"ProfitsInSalary": 4323,
				"IncomeNotified89A": 879,
				"IncomeNotifiedOther89A": 5789,
				"Increliefus89A": 24,
				"NetSalary": 242344,
				"DeductionUs16": 1000,
				"DeductionUs16ia": 999,
				"EntertainmentAlw16ii": 1000,
				"ProfessionalTaxUs16iii": 998,
				"TypeOfHP": "S",
				"GrossRentReceived": 0,
				"TaxPaidlocalAuth": 0,
				"AnnualValue": 0,
				"StandardDeduction": 3,
				"InterestPayable": 8790,
				"ArrearsUnrealizedRentRcvd": 887,
				"DeductionUs57iia": 0,
				"Increliefus89AOS": 0
			},
			"ITR1_TaxComputation": {
				"TotalTaxPayable": 0,
				"Rebate87A": 0,
				"TaxPayableOnRebate": 0,
				"EducationCess": 0,
				"GrossTaxLiability": 0,
				"Section89": 0,
				"NetTaxLiability": 0,
				"TotalIntrstPay": 0,
				"IntrstPay": {
					"IntrstPayUs234A": 0,
					"IntrstPayUs234B": 0,
					"IntrstPayUs234C": 0,
					"LateFilingFee234F": 0
				},
				"TotTaxPlusIntrstPay": 0
			},
			"TaxPaid": {
				"TaxesPaid": {
					"AdvanceTax": 67900,
					"TDS": 44578,
					"TCS": 0,
					"SelfAssessmentTax": 0,
					"TotalTaxesPaid": 0
				},
				"BalTaxPayable": 0
			},
			"Refund": {
				"RefundDue": 0,
				"BankAccountDtls": {
					"AddtnlBankDetails": [
						{
							"UseForRefund": "true",
							"IFSCCode": "UBIB0REYTR657",
							"BankName": "UBI",
							"BankAccountNo": "76968977076876575"
						},
						{
							"UseForRefund": "false",
							"IFSCCode": "UBIB0REYTR657",
							"BankName": "SBI",
							"BankAccountNo": "76968977076876575"
						}
					]
				}
			},
			"PartB-ATI": {
				"ScheduleIT1": {
					"TaxPayment1": {
						"ITTaxPayments": []
					},
					"Total": 0
				},
				"ScheduleIT2": {
					"TaxPayment2": {
						"ITTaxPayments": []
					},
					"Total": 0
				},
				"ReleifUS89": 0,
				"HeadOfInc": {
					"Salaries": 4359869,
					"IncomeFromHP": 0,
					"IncomeFromBP": 0,
					"IncomeFromCG": 0,
					"IncomeFromOS": 0,
					"Total": 4359868
				},
				"UpdatedTotInc": 0,
				"LatestTotInc": 0,
				"AmtPayable": 5478,
				"AmtRefundable": 0,
				"LastAmtPayable": 0,
				"Refund": 0,
				"TotRefund": 0,
				"FeeIncUS234F": 0,
				"RegAssessementTAX": 0,
				"AggrLiabilityRefund": 0,
				"AggrLiabilityNoRefund": 0,
				"AddtnlIncTax": 0,
				"NetPayable": 0,
				"TaxUS140B": 0,
				"TaxDue10_11": 0
			},
			"Schedule80G": {
				"Don100Percent": {
					"DoneeWithPan": [
						{
							"AddressDetail": {
								"AddrDetail": "uitiuTest",
								"CityOrTownOrDistrict": "Test",
								"StateCode": "18",
								"PinCode": 452010
							},
							"DonationAmtCash": 7568,
							"DonationAmtOtherMode": 1,
							"DonationAmt": 986,
							"EligibleDonationAmt": 9875,
							"DoneeWithPanName": "GTRE",
							"DoneePAN": "ERTRY0989J",
							"ArnNbr": "758876979"
						}
					],
					"TotDon100PercentCash": 0,
					"TotDon100PercentOtherMode": 0,
					"TotDon100Percent": 0,
					"TotEligibleDon100Percent": 0
				},
				"Don50PercentNoApprReqd": {
					"DoneeWithPan": [],
					"TotDon50PercentNoApprReqdCash": 0,
					"TotDon50PercentNoApprReqdOtherMode": 0,
					"TotDon50PercentNoApprReqd": 0,
					"TotEligibleDon50Percent": 0
				},
				"Don100PercentApprReqd": {
					"DoneeWithPan": [],
					"TotDon100PercentApprReqdCash": 0,
					"TotDon100PercentApprReqdOtherMode": 0,
					"TotDon100PercentApprReqd": 0,
					"TotEligibleDon100PercentApprReqd": 0
				},
				"Don50PercentApprReqd": {
					"DoneeWithPan": [],
					"TotDon50PercentApprReqdCash": 0,
					"TotDon50PercentApprReqdOtherMode": 0,
					"TotDon50PercentApprReqd": 0,
					"TotEligibleDon50PercentApprReqd": 0
				},
				"TotalDonationsUs80GCash": 0,
				"TotalDonationsUs80GOtherMode": 0,
				"TotalDonationsUs80G": 0,
				"TotalEligibleDonationsUs80G": 0
			},
			"Schedule80GGA": {
				"DonationDtlsSciRsrchRuralDev": [],
				"TotalDonationAmtCash80GGA": 0,
				"TotalDonationAmtOtherMode80GGA": 0,
				"TotalDonationsUs80GGA": 0,
				"TotalEligibleDonationAmt80GGA": 0
			},
			"Schedule80D": {
				"Sec80DSelfFamSrCtznHealth": {
					"SeniorCitizenFlag": "N",
					"SelfAndFamily": 0,
					"HealthInsPremSlfFam": 0,
					"PrevHlthChckUpSlfFam": 0,
					"SelfAndFamilySeniorCitizen": 0,
					"HlthInsPremSlfFamSrCtzn": 0,
					"PrevHlthChckUpSlfFamSrCtzn": 0,
					"MedicalExpSlfFamSrCtzn": 0,
					"ParentsSeniorCitizenFlag": "N",
					"Parents": 0,
					"HlthInsPremParents": 0,
					"PrevHlthChckUpParents": 0,
					"ParentsSeniorCitizen": 0,
					"HlthInsPremParentsSrCtzn": 0,
					"PrevHlthChckUpParentsSrCtzn": 0,
					"MedicalExpParentsSrCtzn": 0,
					"EligibleAmountOfDedn": 0
				}
			},
			"TDSonSalaries": {
				"TDSonSalary": [
					{
						"EmployerOrDeductorOrCollectDetl": {
							"TAN": "HYDY53456R",
							"EmployerOrDeductorOrCollecterName": "EDS"
						},
						"IncChrgSal": 4534003,
						"TotalTDSSal": 345355
					}
				],
				"TotalTDSonSalaries": 345355
			},
			"TDSonOthThanSals": {
				"TDSonOthThanSal": [],
				"TotalTDSonOthThanSals": 1
			},
			"ScheduleTDS3Dtls": {
				"TDS3Details": [],
				"TotalTDS3Details": 1
			},
			"ScheduleTCS": {
				"TCS": [],
				"TotalSchTCS": 0
			},
			"TaxPayments": {
				"TaxPayment": [],
				"TotalTaxPayments": 0
			},
			"Verification": {
				"Declaration": {
					"AssesseeVerName": "Rohit S",
					"FatherName": "Rajendra",
					"AssesseeVerPAN": "ERTPW8979R"
				},
				"Capacity": "S",
				"Place": "Inore"
			},
			"TaxReturnPreparer": {
				"IdentificationNoOfTRP": "6938622",
				"NameOfTRP": "Test Name",
				"ReImbFrmGov": 234
			}
		}
	}
};

export const CurrAssismentYear = new Date(`31 Mar ${new Date().getFullYear()}`);

export const MaritalStatus = ["Married", "Unmarried", "Prefer not to disclose"];

export const FileForStatus = ["Individual", "HUF", "Firm (Other than LLP)"];

export const CountryWithCode: { [key: string]: string } = {
	"1": "CANADA",
	"2": "UNITED STATES OF AMERICA",
	"5": "ITALY",
	"6": "HOLY SEE",
	"7": "KAZAKHSTAN",
	"8": "RUSSIAN FEDERATION",
	"9": "CHRISTMAS ISLAND",
	"14": "PORTUGAL",
	"15": "NORFOLK ISLAND",
	"20": "EGYPT",
	"28": "SOUTH AFRICA",
	"30": "GREECE",
	"31": "NETHERLANDS",
	"32": "BELGIUM",
	"33": "FRANCE",
	"35": "SPAIN",
	"36": "HUNGARY",
	"40": "ROMANIA",
	"41": "SWITZERLAND",
	"43": "AUSTRIA",
	"44": "UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND",
	"45": "DENMARK",
	"46": "SWEDEN",
	"47": "NORWAY",
	"48": "POLAND",
	"49": "GERMANY",
	"51": "PERU",
	"52": "MEXICO",
	"53": "CUBA",
	"54": "ARGENTINA",
	"55": "BRAZIL",
	"56": "CHILE",
	"57": "COLOMBIA",
	"58": "VENEZUELA (BOLIVARIAN REPUBLIC OF)",
	"60": "MALAYSIA",
	"61": "AUSTRALIA",
	"62": "INDONESIA",
	"63": "PHILIPPINES",
	"64": "NEW ZEALAND",
	"65": "SINGAPORE",
	"66": "THAILAND",
	"81": "JAPAN",
	"82": "KOREA (REPUBLIC OF)",
	"84": "VIET NAM",
	"86": "CHINA",
	"90": "TURKEY",
	"91": "INDIA",
	"92": "PAKISTAN",
	"93": "AFGHANISTAN",
	"94": "SRI LANKA",
	"95": "MYANMAR",
	"98": "IRAN (ISLAMIC REPUBLIC OF)",
	"211": "SOUTH SUDAN",
	"212": "MOROCCO",
	"213": "ALGERIA",
	"216": "TUNISIA",
	"218": "LIBYA",
	"220": "GAMBIA",
	"221": "SENEGAL",
	"222": "MAURITANIA",
	"223": "MALI",
	"224": "GUINEA",
	"225": "CÔTE D'IVOIRE",
	"226": "BURKINA FASO",
	"227": "NIGER",
	"228": "TOGO",
	"229": "BENIN",
	"230": "MAURITIUS",
	"231": "LIBERIA",
	"232": "SIERRA LEONE",
	"233": "GHANA",
	"234": "NIGERIA",
	"235": "CHAD",
	"236": "CENTRAL AFRICAN REPUBLIC",
	"237": "CAMEROON",
	"238": "CABO VERDE",
	"239": "SAO TOME AND PRINCIPE",
	"240": "EQUATORIAL GUINEA",
	"241": "GABON",
	"242": "CONGO",
	"243": "CONGO (DEMOCRATIC REPUBLIC OF THE)",
	"244": "ANGOLA",
	"245": "GUINEA-BISSAU",
	"248": "SEYCHELLES",
	"249": "SUDAN",
	"250": "RWANDA",
	"251": "ETHIOPIA",
	"252": "SOMALIA",
	"253": "DJIBOUTI",
	"254": "KENYA",
	"255": "TANZANIA, UNITED REPUBLIC OF",
	"256": "UGANDA",
	"257": "BURUNDI",
	"258": "MOZAMBIQUE",
	"260": "ZAMBIA",
	"261": "MADAGASCAR",
	"262": "RÉUNION",
	"263": "ZIMBABWE",
	"264": "NAMIBIA",
	"266": "LESOTHO",
	"267": "BOTSWANA",
	"268": "SWAZILAND",
	"269": "MAYOTTE",
	"270": "COMOROS",
	"290": "SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA",
	"291": "ERITREA",
	"297": "ARUBA",
	"298": "FAROE ISLANDS",
	"299": "GREENLAND",
	"350": "GIBRALTAR",
	"352": "LUXEMBOURG",
	"353": "IRELAND",
	"354": "ICELAND",
	"355": "ALBANIA",
	"356": "MALTA",
	"357": "CYPRUS",
	"358": "FINLAND",
	"359": "BULGARIA",
	"370": "LITHUANIA",
	"371": "LATVIA",
	"372": "ESTONIA",
	"373": "MOLDOVA (REPUBLIC OF)",
	"374": "ARMENIA",
	"375": "BELARUS",
	"376": "ANDORRA",
	"377": "MONACO",
	"378": "SAN MARINO",
	"380": "UKRAINE",
	"381": "SERBIA",
	"382": "MONTENEGRO",
	"385": "CROATIA",
	"386": "SLOVENIA",
	"387": "BOSNIA AND HERZEGOVINA",
	"389": "MACEDONIA(THE FORMER YUGOSLAV REPUBLIC OF)",
	"420": "CZECHIA",
	"421": "SLOVAKIA",
	"423": "LIECHTENSTEIN",
	"500": "FALKLAND ISLANDS (MALVINAS)",
	"501": "BELIZE",
	"502": "GUATEMALA",
	"503": "EL SALVADOR",
	"504": "HONDURAS",
	"505": "NICARAGUA",
	"506": "COSTA RICA",
	"507": "PANAMA",
	"508": "SAINT PIERRE AND MIQUELON",
	"509": "HAITI",
	"590": "GUADELOUPE",
	"591": "BOLIVIA (PLURINATIONAL STATE OF)",
	"592": "GUYANA",
	"593": "ECUADOR",
	"594": "FRENCH GUIANA",
	"595": "PARAGUAY",
	"596": "MARTINIQUE",
	"597": "SURINAME",
	"598": "URUGUAY",
	"670": "TIMOR-LESTE (EAST TIMOR)",
	"672": "COCOS (KEELING) ISLANDS",
	"673": "BRUNEI DARUSSALAM",
	"674": "NAURU",
	"675": "PAPUA NEW GUINEA",
	"676": "TONGA",
	"677": "SOLOMON ISLANDS",
	"678": "VANUATU",
	"679": "FIJI",
	"680": "PALAU",
	"681": "WALLIS AND FUTUNA",
	"682": "COOK ISLANDS",
	"683": "NIUE",
	"684": "AMERICAN SAMOA",
	"685": "SAMOA",
	"686": "KIRIBATI",
	"687": "NEW CALEDONIA",
	"688": "TUVALU",
	"689": "FRENCH POLYNESIA",
	"690": "TOKELAU",
	"691": "MICRONESIA (FEDERATED STATES OF)",
	"692": "MARSHALL ISLANDS",
	"850": "KOREA(DEMOCRATIC PEOPLE'S REPUBLIC OF)",
	"852": "HONG KONG",
	"853": "MACAO",
	"855": "CAMBODIA",
	"856": "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
	"880": "BANGLADESH",
	"886": "TAIWAN",
	"960": "MALDIVES",
	"961": "LEBANON",
	"962": "JORDAN",
	"963": "SYRIAN ARAB REPUBLIC",
	"964": "IRAQ",
	"965": "KUWAIT",
	"966": "SAUDI ARABIA",
	"967": "YEMEN",
	"968": "OMAN",
	"970": "PALESTINE, STATE OF",
	"971": "UNITED ARAB EMIRATES",
	"972": "ISRAEL",
	"973": "BAHRAIN",
	"974": "QATAR",
	"975": "BHUTAN",
	"976": "MONGOLIA",
	"977": "NEPAL",
	"992": "TAJIKISTAN",
	"993": "TURKMENISTAN",
	"994": "AZERBAIJAN",
	"995": "GEORGIA",
	"996": "KYRGYZSTAN",
	"998": "UZBEKISTAN",
	"1001": "ÅLAND ISLANDS",
	"1002": "BONAIRE, SINT EUSTATIUS AND SABA",
	"1003": "BOUVET ISLAND",
	"1004": "FRENCH SOUTHERN TERRITORIES",
	"1005": "HEARD ISLAND AND MCDONALD ISLANDS",
	"1006": "SAINT BARTHÉLEMY",
	"1007": "SAINT MARTIN (FRENCH PART)",
	"1008": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
	"1009": "UNITED STATES MINOR OUTLYING ISLANDS",
	"1010": "ANTARCTICA",
	"1011": "PITCAIRN",
	"1012": "SVALBARD AND JAN MAYEN",
	"1013": "WESTERN SAHARA",
	"1014": "BRITISH INDIAN OCEAN TERRITORY",
	"1015": "CURAÇAO",
	"1242": "BAHAMAS",
	"1246": "BARBADOS",
	"1264": "ANGUILLA",
	"1268": "ANTIGUA AND BARBUDA",
	"1284": "VIRGIN ISLANDS (BRITISH)",
	"1340": "VIRGIN ISLANDS (U.S.)",
	"1345": "CAYMAN ISLANDS",
	"1441": "BERMUDA",
	"1473": "GRENADA",
	"1481": "GUERNSEY",
	"1534": "JERSEY",
	"1624": "ISLE OF MAN",
	"1649": "TURKS AND CAICOS ISLANDS",
	"1664": "MONTSERRAT",
	"1670": "NORTHERN MARIANA ISLANDS",
	"1671": "GUAM",
	"1721": "SINT MAARTEN (DUTCH PART)",
	"1758": "SAINT LUCIA",
	"1767": "DOMINICA",
	"1784": "SAINT VINCENT AND THE GRENADINES",
	"1787": "PUERTO RICO",
	"1809": "DOMINICAN REPUBLIC",
	"1868": "TRINIDAD AND TOBAGO",
	"1869": "SAINT KITTS AND NEVIS",
	"1876": "JAMAICA",
	"9999": "OTHERS"
};

export const StateWithCode: { [key: string]: string } = {
	"10": "Goa",
	"11": "Gujarat",
	"12": "Haryana",
	"13": "Himachal Pradesh",
	"14": "Jammu and Kashmir",
	"15": "Karnataka",
	"16": "Kerala",
	"17": "Lakshadweep",
	"18": "Madhya Pradesh",
	"19": "Maharashtra",
	"20": "Manipur",
	"21": "meghalaya",
	"22": "Mizoram",
	"23": "Nagaland",
	"24": "Odisha",
	"25": "Puducherry",
	"26": "Punjab",
	"27": "Rajasthan",
	"28": "Sikkim",
	"29": "Tamil Nadu",
	"30": "Tripura",
	"31": "Uttar Pradesh",
	"32": "West Bengal",
	"33": "Chhattisgarh",
	"34": "Uttarakhand",
	"35": "Jharkhand",
	"36": "Telangana",
	"37": "Ladakh",
	"01": "Andaman and Nicobar islands",
	"02": "Andhra Pradesh",
	"03": "Arunachal Pradesh",
	"04": "Assam",
	"05": "Bihar",
	"06": "Chandigarh",
	"07": "Dadra Nagar and Haveli",
	"08": "Daman and Diu",
	"09": "Delhi",
	"99": "Foregin"
};

export const GenderOptions: { [key: string]: string } = {
	"male": "Male",
	"female": "Female"
};

export const ResidentialStatus = ["Resident", "Resident but not Ordinary Resident", "Non-Resident"];

export const DaysInIndiainCurrentFY: { [key: string]: string } = {
	"lessThan60": "Less than 60 days",
	"from60To119": "60-119 days",
	"from120To181": "120-181 days",
	"moreThan182": ">= 182 days"
};

export const CitizenOptions: { [key: string]: string } = {
	"indianOrigin": "Person of Indian origin but a citizen of another country",
	"indianForeignEmployment": "Indian citizen with foreign employment",
	"indianNonTaxableInOtherCountry": "Indian citizen but not a tax resident in any other country",
	"foreignVisitingIndia": "Foreign citizen visiting or coming to India for employment"
};

export const BankAccountType = [
	"Savings",
	"Current",
	"Cash Credit",
	"Over Draft",
	"Non Resident",
	"Other"
];

export const EmployerCategories: { [key: string]: string } = {
	"CGOV": "Central Government",
	"SGOV": "State Government",
	"PSU": "Public Sector Unit",
	"PE": "Pensioners - Central Government",
	"PESG": "Pensioners - State Government",
	"PEPS": "Pensioners - Public Sector Undertaking",
	"PEO": "Pensioners - Others",
	"OTH": "Others"
};

export const EmployerCategoriesForEntertainmentAllowance = ["CGOV", "SGOV", "PSU"];

export const Salary171OtherAllowance = [
	"Dearness Allowance",
	"Conveyance Allowance",
	"Transaport Allowance",
	"Children Education Allowance",
	"Leave Encashment",
	"Advance of Salary",
	"Fees or Commission",
	"Gratuity",
	"Commuted Pension",
	"Annuity or Pension",
	"Contribution by employer towards Pension",
	"Income under Rule 11 4th Schedule",
	"Income under Rule 6 4th Schedule",
	"Contribution made by Central Government towards Agnipath Scheme",
	"Other Allowance",
	"Others"
];

export const Salary172Perquisites = [
	"Accomodation",
	"Cars or other automotives",
	"Credit card expenses",
	"Club expenses",
	"Employer contribution to any fund or scheme",
	"ESOP/Stock Option",
	"Fee or concessional travel",
	"Free education",
	"Free meals",
	"Gas, electricity, water",
	"Gifts, vouchers, etc",
	"Holiday expenses",
	"Interest free or concessional loans",
	"Sweeper, gardener, watchman or personal attendent",
	"Tax paid by employer on non-monetary perquisites",
	"Transfer of assets to employee",
	"Use of movable assests by employee",
	"Annual accretion by way of interest or dividend to the balance",
	"Value of any benefir/amenities/service/previlege",
	"Other beneifts or amenities"
];

export const ProfitsInLieuOfSalary = [
	"Compensation due/received by an assessee from his employer",
	"Any payment due/received by an assessee from his employer",
	"Any amount due/received by an assessee from any other person",
	"Any other"
];

export const NotifiedCountriesCode: { [key: string]: string } = {
	"US": "United States of America",
	"UK": "United Kingdom of Great Britain and Northern Ireland",
	"CA": "Canada"
};

export const Section10ExemptAllowances = [
	"Remuneration received as an official of an embassy,high commision",
	"Allowance or perquisites paid by the government to a citizen of India for rending services outside India",
	"Death-Retirement Gratuity",
	"Commuted value of pension",
	"Earned Leave Encashment on retirement",
	"Amount received on Voluntary retirement or termination of service",
	"Tax paid by employer on non-monetary perquisities",
	"Expemtion on allowances paid to meet personal expenses in performance of duties of employment",
	"Compensation limit notified by CG Sec 10(10B) 1st proviso",
	"Compensation limit notified by CG Sec 10(10B) 2nd proviso",
	"Allowances referred in Rule 2BB - conveyance, travel cost on tour or transfer",
	"Transport allowance to specially abled",
	"Exempt income received by a judge covered under the payment of salaries to Supreme Court/High Court Judges Acts/Rules",
	"Others"
];

export const InterestIncomeOnPF = [
	"Interest on EPF Balance- 1st Proviso to sec 10(11)",
	"Interest on EPF Balance- 2nd Proviso to sec 10(11)",
	"Interest on RPF Balance- 1st Proviso to sec 10(12)",
	"Interest on RPF Balance- 2nd Proviso to sec 10(12)"
];

export const AgriculturalOwnershipStatus = ["Owned", "Held on Lease"];

export const AgriculturalWaterSource = ["Irrigated", "Rain-Fed"];

export const OnlineGamingOptions = [
	"Betting",
	"Card Games",
	"Crossword Puzzle",
	"Gambling",
	"Online Gaming",
	"Other Game shows",
	"Races Including Horse-race",
	"Winning from Lottery",
	"Others"
];

export const IncomeOtherSource = [
	"Rental income from machinery, plants, buildings, etc., Gross",
	"Family Pension",
	"Dividend Income (Taxable) u/s 56(2)(i)",
	"Cash credits u/s 68",
	"Unexplained investments u/s 69",
	"Unexplained money etc. u/s 69A",
	"Undisclosed investments etc. u/s 69B",
	"Unexplained expenditure etc. u/s 69C",
	"Hundi transactions - Amount borrowed or repaid u/s 69D",
	"115A(1)(a)(i) -Dividends interest and income from units purchase in foreign currency",
	"115A(1)(a)(ii)- Interest received from govt/Indian Concerns received in Foreign Currency",
	"115A(1)(a)(iia) -Interest from Infrastructure Debt Fund",
	"115A(1) (a)(iiaa) -Interest as per Sec. 194LC",
	"115A(1)(a)(iiab) -Interest as per Sec. 194LD",
	"115A(1)(a)(iii) - Income received in respect of units of UTI purchased in Foreign Currency",
	"115A(1)(b)(A)- Income from royalty &amp; technical services",
	"115A(1)(b)(B) Income from royalty &amp; technical services",
	"115AC(1)(a &amp; b) - Income from bonds or GDR purchased in foreign currency - non-resident",
	"115AD(1)(i) -Income received by an FII in respect of securities (other than units as per Sec 115AB)",
	"115BBA - Tax on non-residents sportsmen or sports associations",
	"115E(a) - Investment income",
	"115A(1)(a)(iiac) -Interest as per Sec. 194LBA",
	"GDR purchased in Foreign Currency - Resident",
	"115BBF - Tax on income from patent",
	"Others"
];

export const Section57Options = ["Expenses/Deduction", "Dividend Deduction"];

export const OthersIncDtlExemptIncome: { [key: string]: string } = {
	"10(10BC)":
		"Sec 10(10BC)-Any amount from the Central/State Govt./local authority by way of compensation on account of any disaster",
	"10(10D)":
		"Sec 10(10D)- Any sum received under a life insurance policy except mentioned in sub-clause(a) to(d)",
	"10(11)": "Sec 10(11)-Statuory Provident Fund received",
	"10(12)": "Sec 10(12)-Recognised Provident Fund received",
	// "10(12A)": "Sec 10(12A)-Any payment from the National Pension System Trust to an assessee",
	// "10(12B)":
	// 	"Sec 10(12B)-Any payment from the National Pension System Trust to an Central Govt. Employee",
	"10(12C)":
		"Sec 10(12C)-Any payment from Agniveer Corpus Fund to a person enrolled under the Agnipath Scheme or to his nominee",
	"10(13)": "Sec 10(13)-Approved superannuation fund received",
	"10(16)": "Sec 10(16)-Scholarships granted to meet the cost of education",
	"10(17)": "Sec 10(17)-Allownace MP/MLA/MLC",
	"10(17A)": "Sec 10(17A)-Award instituted by Government",
	"10(18)":
		"Sec 10(18)-Pension received by winner of 'Param Vir Chakra' or 'Maha Vir Chakra' or 'Vir Chakra' or such other gallantry award",
	"DMDP": "Defense medical disability pension",
	"10(19)": "Sec 10(19)-Armed Forces Family pension in case of death during operational duty",
	"10(26)": "Sec 10(26)-Any income as referred to in section 10(26)",
	"10(26AAA)": "Sec 10(26AAA)-Any income as referred to in section 10(26AAA)",
	"OTH": "Any Other"
};

export const NotifiedCountriesTimePeriod = [
	"April to Mid June",
	"Mid June to Mid September",
	"Mid September to Mid December",
	"Mid December to Mid March",
	"Mid March to Mid onwards"
];

export const PersonAgeOptions = ["Below 60 years", "60 - 79 years", "More than 80 years"];

export const DeductionLimitOptions: { [key: string]: string } = {
	"NO_LIMIT": "No Limit",
	"SUBJECT_TO_INCOME": "Subject To Income"
};

export const QualifyingPercentageOptions: { [key: string]: string } = {
	"50": "50%",
	"100": "100%"
};

export const PhysicalDisability: { [key: string]: string } = {
	"FORTY_PERCENT_DISABILITY": "40% Disability",
	"SEVERE_DISABILITY": "80% Disability",
	"NONE": "None"
};

export const DisabledDependentNature: { [key: string]: string } = {
	"FORTY_PERCENT_DISABILITY": "40% Disability",
	"SEVERE_DISABILITY": "Severe Disability"
};

export const DisabledDependentRelation: { [key: string]: string } = {
	"FATHER": "Father",
	"MOTHER": "Mother",
	"BROTHER": "Brother",
	"SISTER": "Sister",
	"DAUGHTER": "Daughter"
};

export const Common80GOrganizationsOptions = [
	"PM CARES - COVID-19 RELIEF FUND",
	"MAHARASHTRA CM COVID-19 RELIEF FUND",
	"WEST BENGAL STATE EMERGENCY RELIEF FUND-COVID 19",
	"TAMIL NADU CM PUBLIC RELIEF FUND-COVID 19",
	"NCT DELHI LT. GOVERNER/CHIEF MINISTER RELIEF FUND-",
	"PRIME MINISTERS NATIONAL RELIEF FUND",
	"INDIAN NAVAL BENEVOLENT ASSOCIATION (INBA",
	"GUJARAT CHIEF MINISTER'S RELIEF FUND",
	"BAL RAKSHA BHARAT",
	"KALINGA INSTITUTE OF SOCIAL SCIENCES",
	"VIDYARAMBHAM TRUST",
	"LITTLE SISTERS OF THE POOR",
	"WORLD VISION INDIA",
	"ANDGRAPRADESH CHIEF MINISTER RELIEF FUND",
	"SHRI VINAYAKARAO SHIRGAOKAR PRATISTHAN",
	"CHARITIES AID FOUNDATION OF INDIA",
	"CRY CHILD RELIEF AND YOU",
	"MUKHYA MANTRI RAHAT KOSH UTTARAKHAND",
	"GIVE FOUNDATION",
	"CHILD CARE FOUNDATION",
	"RELIEF INDIA TRUST",
	"SOS CHILDRENS VILLAGE OF INDIA",
	"JKG EDUCATIONAL AND WELFARE SOCIETY",
	"SAMARTHANAM TRUST FOR DISABLED",
	"THE TATA RELIEF COMMITTEE",
	"ASSAM CHIEF MINISTER's RELIEF FUND",
	"KERALA CHIEF MINISTER's DISTRESS RELIEF FUND",
	"KARNATAKA CM RELIEF FUND",
	"ODISHA - CHIEF MINISTER'S RELIEF FUND"
];

export const RelevantClauseOptions: { [key: string]: string } = {
	"80GGA2a":
		"80GGA(2)(a) - Sum paid to Research Association or University, college or other institution for Scientific Research",
	"80GGA2aa":
		"80GGA(2)(aa) - Sum paid to Research Association or University, college or other institution for Social science or Statistical Research",
	"80GGA2b": "80GGA(2)(b) - Sum paid to an association or institution for Rural Development",
	"80GGA2bb":
		"80GGA(2)(bb) - Sum paid to PSU or Local Authority or an association or institution approved by the National Committee for carrying out any eligible project",
	"80GGA2c":
		"80GGA(2)(c) - Sum paid to an association or institution for Conservation of Natural Resources or for afforestation",
	"80GGA2cc":
		"80GGA(2)(cc) - Sum paid for Afforestation, to the funds, which are notified by Central Govt.",
	"80GGA2d":
		"80GGA(2)(d) - Sum paid for Rural Development to the funds, which are notified by Central Govt.",
	"80GGA2e":
		"80GGA(2)(e) - Sum paid to National Urban Poverty Eradication Fund as setup and notified by Central Govt."
};

export const TDSCreditRelatingToOptions = [
	"Self (For transfer of TDS Credit)",
	"Others (For claiming of TDS Credit)"
];

export const TypeOfIncomeOptions: { [key: string]: string } = {
	"BP": "Business & Profession",
	"SA": "Salary",
	"HP": "House Property",
	"CG": "Capital Gain",
	"OS": "Other sources",
	"EI": "Exempt Income",
	"NA": "Not Applicable - TDS us 194N",
	"CCG": "Crypto - Capital Gain",
	"CBP": "Crypto - Business & Profession"
};

export const TCSCreditRelatingToOptions = [
	"Self (For transfer of TCS Credit)",
	"Others (For claiming of TCS Credit)"
];

export const ImmovableTypeOfIncomeOptions: { [key: string]: string } = {
	"CG": "Capital Gain",
	"HP": "House Property"
};

export const HousePropertTypes: { [key: string]: string } = {
	"self": "Self Occupied House Property",
	"deemed": "Deemed Let Out Property"
};

export const PropertTypes = {
	SELF: "self",
	DEEMED: "deemed"
};

export const RIHousePropertTypes = ["Let Out Property", "Deemed Let Out Property"];

export const CapitalGainsTypesOptions = [
	"Stocks",
	"Mutual Fund",
	"Foreign Listed Shares",
	"Sale of Land and Building",
	"Stock Options and RSUs",
	"Bonds and Debenture",
	"Deemed Capital Gains",
	"Any Other Assets"
];

// used in other assests income details

export const ProfesssionalDetailsDropdown = [
	"Computer And Related Service",
	"Profession",
	"Healthcare Services",
	"Culture And Sports"
];

export const FSAssetsTypesOptions = ["Listed", "Unlisted"];

export const AssetsTypesOptions: { [key: string]: string } = {
	Listed_Long_10_Per: "Listed Securities - Long term u/s 112",
	Listed_Short_15_Per: "Listed Securities - Short term u/s 111A",
	Unlisted_Normal: "Unlisted securities - Long term",
	Unlisted_Short_20_Per: "Unlisted securities - Short term"
};

export const StockAssetsTypes = {
	Listed_Long_10_Per: "Listed_Long_10_Per",
	Listed_Short_15_Per: "Listed_Short_15_Per",
	Unlisted_Normal: "Unlisted_Normal",
	Unlisted_Short_20_Per: "Unlisted_Short_20_Per"
};

export const AcquisitionOptions: { [key: string]: string } = {
	After_31_01_2018: "After 31/01/2018",
	On_or_Before_31_01_2018: "On or before 31/01/2018"
};

export const AcquisitionTypes = {
	After_31_01_2018: "After_31_01_2018",
	On_or_Before_31_01_2018: "On_or_Before_31_01_2018"
};

export const MFAssetsTypesOptions: { [key: string]: string } = {
	Listed_Long_10_Per: "Listed & Long Term",
	Listed_Short_15_Per: "Listed & Short Term",
	Unlisted_Short_20_Per: "Unlisted & Long Term",
	Unlisted_Normal: "Unlisted & Short Term"
};

export const MFAssetsTypes = {
	Listed_Long_10_Per: "Listed_Long_10_Per",
	Listed_Short_15_Per: "Listed_Short_15_Per",
	Unlisted_Normal: "Unlisted_Normal",
	Unlisted_Short_20_Per: "Unlisted_Short_20_Per"
};

export const StockRSUTypesOptions = [
	"Indian ESOP&RSU - Listed",
	"Indian ESOP&RSU - Unlisted",
	"Foreign RSU&ESOP - Listed",
	"Foreign RSU&ESOP - Unlisted"
];

// Business code used inside business and professional incomes section
export const BusinessIncomesBusinessCode44AD: { [key: string]: string } = {
	"01001": "01001 - Growing and manufacturing of tea",
	"01002": "01002 - Growing and manufacturing of coffee",
	"01003": "01003 - Growing and manufacturing of rubber",
	"01004": "01004 - Market gardening and horticulture specialties",
	"01005": "01005 - Raising of silk worms and production of silk",
	"01006": "01006 - Raising of bees and production of honey",
	"01007": "01007 - Raising of poultry and production of eggs",
	"01008": "01008 - Rearing of sheep and production of wool",
	"01009": "01009 - Rearing of animals and production of animal products",
	"01010": "01010 - Agricultural and animal husbandry services",
	"01011": "01011 - Soil conservation, soil testing and soil desalination services",
	"01012": "01012 - Hunting, trapping and game propagation services",
	"01013":
		"01013 - Growing of timber, plantation, operation of tree nurseries and conserving of forest",
	"01014": "01014 - Gathering of tendu leaves",
	"01015": "01015 - Gathering of other wild growing materials",
	"01016": "01016 - Forestry service activities, timber cruising, afforestation and reforestation",
	"01017": "01017 - Logging service activities, transport of logs within the forest",
	"01018": "01018 - Other agriculture, animal husbandry or forestry activity n.e.c",
	"02001": "02001 - Fishing on commercial basis in inland waters",
	"02002": "02002 - Fishing on commercial basis in ocean and coastal areas",
	"02003": "02003 - Fish farming",
	"02004": "02004 - Gathering of marine materials such as natural pearls, sponges, coral etc.",
	"02005":
		"02005 - Services related to marine and fresh water fisheries, fish hatcheries and fish farms",
	"02006": "02006 - Other Fish farming activity n.e.c",
	"03001": "03001 - Mining and agglomeration of hard coal",
	"03002": "03002 - Mining and agglomeration of lignite",
	"03003": "03003 - Extraction and agglomeration of peat",
	"03004": "03004 - Extraction of crude petroleum and natural gas",
	"03005": "03005 - Service activities incidental to oil and gasextraction excluding surveying",
	"03006": "03006 - Mining of uranium and thorium ores",
	"03007": "03007 - Mining of iron ores",
	"03008": "03008 - Mining of non-ferrous metal ores, except uranium and thorium ores",
	"03009": "03009 - Mining of gemstones",
	"03010": "03010 - Mining of chemical and fertilizer minerals",
	"03011": "03011 - Mining of quarrying of abrasive materials",
	"03012": "03012 - Mining of mica, graphite and asbestos",
	"03013": "03013 - Quarrying of stones (marble/granite/dolomite), sand and clay",
	"03014": "03014 - Other mining and quarrying",
	"03015": "03015 - Mining and production of salt",
	"03016": "03016 - Other mining and quarrying n.e.c",
	"04001": "04001 - Production, processing and preservation of meat and meat products",
	"04002": "04002 - Production, processing and preservation of fish and fish products",
	"04003": "04003 - Manufacture of vegetable oil, animal oil and fats",
	"04004": "04004 - Processing of fruits, vegetables and edible nuts",
	"04005": "04005 - Manufacture of dairy products",
	"04006": "04006 - Manufacture of sugar",
	"04007": "04007 - Manufacture of cocoa, chocolates and sugar confectionery",
	"04008": "04008 - Flour milling",
	"04009": "04009 - Rice milling",
	"04010": "04010 - Dal milling",
	"04011": "04011 - Manufacture of other grain mill products",
	"04012": "04012 - Manufacture of bakery products",
	"04013": "04013 - Manufacture of starch products",
	"04014": "04014 - Manufacture of animal feeds",
	"04015": "04015 - Manufacture of other food products",
	"04016": "04016 - Manufacturing of wines",
	"04017": "04017 - Manufacture of beer",
	"04018": "04018 - Manufacture of malt liquors",
	"04019": "04019 - Distilling and blending of spirits, production of ethyl alcohol",
	"04020": "04020 - Manufacture of mineral water",
	"04021": "04021 - Manufacture of soft drinks",
	"04022": "04022 - Manufacture of other non-alcoholic beverages",
	"04023": "04023 - Manufacture of tobacco products",
	"04024": "04024 - Manufacture of textiles (other than by handloom)",
	"04025": "04025 - Manufacture of textiles using handlooms (khadi)",
	"04026": "04026 - Manufacture of carpet, rugs, blankets, shawls etc. (other than by hand)",
	"04027": "04027 - Manufacture of carpet, rugs, blankets, shawls etc. by hand",
	"04028": "04028 - Manufacture of wearing apparel",
	"04029": "04029 - Tanning and dressing of leather",
	"04030": "04030 - Manufacture of luggage, handbags and the like saddler and harness",
	"04031": "04031 - Manufacture of footwear",
	"04032": "04032 - Manufacture of wood and wood products, cork, straw and plaiting material",
	"04033": "04033 - Manufacture of paper and paper products",
	"04034": "04034 - Publishing, printing and reproduction of recorded media",
	"04035": "04035 - Manufacture of coke oven products",
	"04036": "04036 - Manufacture of refined petroleum products",
	"04037": "04037 - Processing of nuclear fuel",
	"04038": "04038 - Manufacture of fertilizers and nitrogen compounds",
	"04039": "04039 - Manufacture of plastics in primary forms and of synthetic rubber",
	"04040": "04040 - Manufacture of paints, varnishes and similar coatings",
	"04041": "04041 - Manufacture of pharmaceuticals, medicinal chemicals and botanical products",
	"04042": "04042 - Manufacture of soap and detergents",
	"04043": "04043 - Manufacture of other chemical products",
	"04044": "04044 - Manufacture of man-made fibers",
	"04045": "04045 - Manufacture of rubber products",
	"04046": "04046 - Manufacture of plastic products",
	"04047": "04047 - Manufacture of glass and glass products",
	"04048": "04048 - Manufacture of cement, lime and plaster",
	"04049": "04049 - Manufacture of articles of concrete, cement and plaster",
	"04050": "04050 - Manufacture of Bricks",
	"04051": "04051 - Manufacture of other clay and ceramic products",
	"04052": "04052 - Manufacture of other non-metallic mineral products",
	"04053": "04053 - Manufacture of pig iron, sponge iron, Direct Reduced Iron etc.",
	"04054": "04054 - Manufacture of Ferro alloys",
	"04055": "04055 - Manufacture of Ingots, billets, blooms and slabs etc.",
	"04056": "04056 - Manufacture of steel products",
	"04057": "04057 - Manufacture of basic precious and non-ferrous metals",
	"04058": "04058 - Manufacture of non-metallic mineral products",
	"04059": "04059 - Casting of metals",
	"04060": "04060 - Manufacture of fabricated metal products",
	"04061": "04061 - Manufacture of engines and turbines",
	"04062": "04062 - Manufacture of pumps and compressors",
	"04063": "04063 - Manufacture of bearings and gears",
	"04064": "04064 - Manufacture of ovens and furnaces",
	"04065": "04065 - Manufacture of lifting and handling equipment",
	"04066": "04066 - Manufacture of other general purpose machinery",
	"04067": "04067 - Manufacture of agricultural and forestry machinery",
	"04068": "04068 - Manufacture of Machine Tools",
	"04069": "04069 - Manufacture of machinery for metallurgy",
	"04070": "04070 - Manufacture of machinery for mining, quarrying and constructions",
	"04071": "04071 - Manufacture of machinery for processing of food and beverages",
	"04072": "04072 - Manufacture of machinery for leather and textile",
	"04073": "04073 - Manufacture of weapons and ammunition",
	"04074": "04074 - Manufacture of other special purpose machinery",
	"04075": "04075 - Manufacture of domestic appliances",
	"04076": "04076 - Manufacture of office, accounting and computing machinery",
	"04077": "04077 - Manufacture of electrical machinery and apparatus",
	"04078": "04078 - Manufacture of Radio, Television, communication equipment and apparatus",
	"04079": "04079 - Manufacture of medical and surgical equipment",
	"04080": "04080 - Manufacture of industrial process control equipment",
	"04081": "04081 - Manufacture of instruments and appliances for measurements and navigation",
	"04082": "04082 - Manufacture of optical instruments",
	"04083": "04083 - Manufacture of watches and clocks",
	"04084": "04084 - Manufacture of motor vehicles",
	"04085": "04085 - Manufacture of body of motor vehicles",
	"04086": "04086 - Manufacture of parts & accessories of motor vehicles & engines",
	"04087": "04087 - Building & repair of ships and boats",
	"04088": "04088 - Manufacture of railway locomotive and rolling stocks",
	"04089": "04089 - Manufacture of aircraft and spacecraft",
	"04090": "04090 - Manufacture of bicycles",
	"04091": "04091 - Manufacture of other transport equipment",
	"04092": "04092 - Manufacture of furniture",
	"04093": "04093 - Manufacture of jewellery",
	"04094": "04094 - Manufacture of sports goods",
	"04095": "04095 - Manufacture of musical instruments",
	"04096": "04096 - Manufacture of games and toys",
	"04097": "04097 - Other manufacturing n.e.c.",
	"04098": "04098 - Recycling of metal waste and scrap",
	"04099": "04099 - Recycling of non- metal waste and scrap",
	"05001": "05001 - Production, collection and distribution of electricity",
	"05002": "05002 - Manufacture and distribution of gas",
	"05003": "05003 - Collection, purification and distribution of water",
	"05004": "05004 - Other essential commodity service n.e.c",
	"06001": "06001 - Site preparation works",
	"06002": "06002 - Building of complete constructions or parts- civil contractors",
	"06003": "06003 - Building installation",
	"06004": "06004 - Building completion",
	"06005":
		"06005 - Construction and maintenance of roads, rails, bridges, tunnels, ports, harbour, runways etc.",
	"06006": "06006 - Construction and maintenance of power plants",
	"06007": "06007 - Construction and maintenance of industrial plants",
	"06008": "06008 - Construction and maintenance of power transmission and telecommunication lines",
	"06009": "06009 - Construction of water ways and water reservoirs",
	"06010": "06010 - Other construction activity n.e.c.",
	"07001":
		"07001 - Purchase, sale and letting of leased buildings (residential and non-residential)",
	"07002":
		"07002 - Operating of real estate of self-owned buildings (residential and non-residential)",
	"07003": "07003 - Developing and sub-dividing real estate into lots",
	"07004": "07004 - Real estate activities on a fee or contract basis",
	"07005": "07005 - Other real estate/renting services n.e.c",
	"08001": "08001 - Renting of land transport equipment",
	"08002": "08002 - Renting of water transport equipment",
	"08003": "08003 - Renting of air transport equipment",
	"08004": "08004 - Renting of agricultural machinery and equipment",
	"08005": "08005 - Renting of construction and civil engineering machinery",
	"08006": "08006 - Renting of office machinery and equipment",
	"08007": "08007 - Renting of other machinery and equipment n.e.c.",
	"08008": "08008 - Renting of personal and household goods n.e.c.",
	"08009": "08009 - Renting of other machinery n.e.c.",
	"09001": "09001 - Wholesale and retail sale of motor vehicles",
	"09002": "09002 - Repair and maintenance of motor vehicles",
	"09003": "09003 - Sale of motor parts and accessories- wholesale and retail",
	"09004": "09004 - Retail sale of automotive fuel",
	"09005": "09005 - General commission agents, commodity brokers and auctioneers",
	"09006": "09006 - Wholesale of agricultural raw material",
	"09007": "09007 - Wholesale of food & beverages and tobacco",
	"09008": "09008 - Wholesale of household goods",
	"09009": "09009 - Wholesale of metals and metal ores",
	"09010": "09010 - Wholesale of household goods",
	"09011": "09011 - Wholesale of construction material",
	"09012": "09012 - Wholesale of hardware and sanitary fittings",
	"09013": "09013 - Wholesale of cotton and jute",
	"09014": "09014 - Wholesale of raw wool and raw silk",
	"09015": "09015 - Wholesale of other textile fibres",
	"09016": "09016 - Wholesale of industrial chemicals",
	"09017": "09017 - Wholesale of fertilizers and pesticides",
	"09018": "09018 - Wholesale of electronic parts & equipment",
	"09019": "09019 - Wholesale of other machinery, equipment and supplies",
	"09020": "09020 - Wholesale of waste, scrap & materials for re-cycling",
	"09021": "09021 - Retail sale of food, beverages and tobacco in specialized stores",
	"09022": "09022 - Retail sale of other goods in specialized stores",
	"09023": "09023 - Retail sale in non-specialized stores",
	"09024": "09024 - Retail sale of textiles, apparel, footwear, leather goods",
	"09025": "09025 - Retail sale of other household appliances",
	"09026": "09026 - Retail sale of hardware, paint and glass",
	"09027": "09027 - Wholesale of other products n.e.c",
	"09028": "09028 - Retail sale of other products n.e.c",
	"10001": "10001 - Hotels  Star rated",
	"10002": "10002 - Hotels  Non-star rated",
	"10003": "10003 - Motels, Inns and Dharmshalas",
	"10004": "10004 - Guest houses and circuit houses",
	"10005": "10005 - Dormitories and hostels at educational institutions",
	"10006": "10006 - Short stay accommodations n.e.c.",
	"10007": "10007 - Restaurants  with bars",
	"10008": "10008 - Restaurants without bars",
	"10009": "10009 - Canteens",
	"10010": "10010 - Independent caterers",
	"10011": "10011 - Casinos and other games of chance",
	"10012": "10012 - Other hospitality services n.e.c.",
	"11001": "11001 - Travel agencies and tour operators",
	"11002": "11002 - Packers and movers",
	"11003": "11003 - Passenger land transport",
	"11004": "11004 - Air transport",
	"11005": "11005 - Transport by urban/sub-urban railways",
	"11006": "11006 - Inland water transport",
	"11007": "11007 - Sea and coastal water transport",
	"11008": "11008 - Freight transport by road",
	"11009": "11009 - Freight transport by railways",
	"11010": "11010 - Forwarding of freight",
	"11011": "11011 - Receiving and acceptance of freight",
	"11012": "11012 - Cargo handling",
	"11013": "11013 - Storage and warehousing",
	"11014":
		"11014 - Transport via pipelines (transport of gases, liquids, slurry and other commodities)",
	"11015": "11015 - Other Transport & Logistics services n.e.c",
	"12001": "12001 - Post and courier activities",
	"12002": "12002 - Basic telecom services",
	"12003": "12003 - Value added telecom services",
	"12004": "12004 - Maintenance of telecom network",
	"12005": "12005 - Activities of the cable operators",
	"12006": "12006 - Other Post & Telecommunication services n.e.c",
	"13001": "13001 - Commercial banks, saving banks and discount houses",
	"13002": "13002 - Specialised institutions granting credit",
	"13003": "13003 - Financial leasing",
	"13004": "13004 - Hire-purchase financing",
	"13005": "13005 - Housing finance activities",
	"13006": "13006 - Commercial loan activities",
	"13007": "13007 - Credit cards",
	"13008": "13008 - Mutual funds",
	"13009": "13009 - Chit fund",
	"13010": "13010 - Investment activities",
	"13011": "13011 - Life insurance",
	"13012": "13012 - Pension funding",
	"13013": "13013 - Non-life insurance",
	"13014": "13014 - Administration of financial markets",
	"13015": "13015 - Stock brokers, sub-brokers and related activities",
	"13016": "13016 - Financial advisers, mortgage advisers and brokers",
	"13017": "13017 - Foreign exchange services",
	"13018": "13018 - Other financial intermediation services n.e.c.",
	"14001": "14001 - Software development",
	"14002": "14002 - Other software consultancy",
	"14003": "14003 - Data processing",
	"14004": "14004 - Database activities and distribution of electronic content",
	"14005": "14005 - Other IT enabled services",
	"14006": "14006 - BPO services",
	"14007": "14007 - Cyber cafe",
	"14008": "14008 - Maintenance and repair of office, accounting and computing machinery",
	"14009": "14009 - Computer training and educational institutes",
	"14010": "14010 - Other computation related services n.e.c.",
	"15001": "15001 - Natural sciences and engineering",
	"15002": "15002 - Social sciences and humanities",
	"15003": "15003 - Other Research & Development activities n.e.c.",
	"16001": "16001 - Legal profession",
	"16002": "16002 - Accounting, book-keeping and auditing profession",
	"16003": "16003 - Tax consultancy",
	"16004": "16004 - Architectural profession",
	"16005": "16005 - Engineering and technical consultancy",
	"16006": "16006 - Advertising",
	"16007": "16007 - Fashion designing",
	"16008": "16008 - Interior decoration",
	"16009": "16009 - Photography",
	"16010": "16010 - Auctioneers",
	"16011": "16011 - Business brokerage",
	"16012": "16012 - Market research and public opinion polling",
	"16013": "16013 - Business and management consultancy activities",
	"16014": "16014 - Labour recruitment and provision of personnel",
	"16015": "16015 - Investigation and security services",
	"16016": "16016 - Building-cleaning and industrial cleaning activities",
	"16017": "16017 - Packaging activities",
	"16018": "16018 - Secretarial activities",
	"16020": "16020 - Film Artist (applicable from AY 20-21)",
	"16019_1": "16019_1 - Medical Profession (applicable from AY 20-21)",
	"16019": "16019 - Other professional services n.e.c.",
	"17001": "17001 - Primary education",
	"17002": "17002 - Secondary/ senior secondary education",
	"17003": "17003 - Technical and vocational secondary/ senior secondary education",
	"17004": "17004 - Higher education",
	"17005": "17005 - Education by correspondence",
	"17006": "17006 - Coaching centres and tuitions",
	"17007": "17007 - Other education services n.e.c.",
	"18001": "18001 - General hospitals",
	"18002": "18002 - Speciality and super speciality hospitals",
	"18003": "18003 - Nursing homes",
	"18004": "18004 - Diagnostic centres",
	"18005": "18005 - Pathological laboratories",
	"18006": "18006 - Independent blood banks",
	"18007": "18007 - Medical transcription",
	"18008": "18008 - Independent ambulance services",
	"18009": "18009 - Medical suppliers, agencies and stores",
	"18010": "18010 - Medical clinics",
	"18011": "18011 - Dental practice",
	"18012": "18012 - Ayurveda practice",
	"18013": "18013 - Unani practice",
	"18014": "18014 - Homeopathy practice",
	"18015": "18015 - Nurses, physiotherapists or other para-medical practitioners",
	"18016": "18016 - Veterinary hospitals and practice",
	"18017": "18017 - Medical education",
	"18018": "18018 - Medical research",
	"18019": "18019 - Practice of alternative medicine",
	"18020": "18020 - Other healthcare services",
	"19001": "19001 - Social work activities with accommodation (orphanages and old age homes)",
	"19002": "19002 - Social work activities without accommodation (Creches)",
	"19003": "19003 - Industry associations, chambers of commerce",
	"19004": "19004 - Professional organisations",
	"19005": "19005 - Trade unions",
	"19006": "19006 - Religious organizations",
	"19007": "19007 - Political organisations",
	"19008":
		"19008 - Other membership organisations n.e.c. (rotary clubs, book clubs and philatelic clubs)",
	"19009": "19009 - Other Social or community service n.e.c",
	"20001": "20001 - Motion picture production",
	"20002": "20002 - Film distribution",
	"20003": "20003 - Film laboratories",
	"20004": "20004 - Television channel productions",
	"20005": "20005 - Television channels broadcast",
	"20006": "20006 - Video production and distribution",
	"20007": "20007 - Sound recording studios",
	"20008": "20008 - Radio - recording and distribution",
	"20009": "20009 - Stage production and related activities",
	"20010": "20010 - Individual artists excluding authors",
	"20011": "20011 - Literary activities",
	"20012": "20012 - Other cultural activities n.e.c.",
	"20013": "20013 - Circuses and race tracks",
	"20014": "20014 - Video Parlours",
	"20015": "20015 - News agency activities",
	"20016": "20016 - Library and archives activities",
	"20017": "20017 - Museum activities",
	"20018": "20018 - Preservation of historical sites and buildings",
	"20019": "20019 - Botanical and zoological gardens",
	"20020": "20020 - Operation and maintenance of sports facilities",
	"20021": "20021 - Activities of sports and game schools",
	"20022":
		"20022 - Organisation and operation of indoor/outdoor sports and promotion and production of sporting events",
	"20023": "20023 - Other sporting activities n.e.c.",
	"20023_1": "20023_1 - Sports Management (applicable from AY 20-21)",
	"20024": "20024 - Other recreational activities n.e.c.",
	"21001": "21001 - Hair dressing and other beauty treatment",
	"21002": "21002 - Funeral and related activities",
	"21003": "21003 - Marriage bureaus",
	"21004": "21004 - Pet care services",
	"21005": "21005 - Sauna and steam baths, massage salons etc.",
	"21006": "21006 - Astrological and spiritualists' activities",
	"21007": "21007 - Private households as employers of domestic staff",
	"21008_1": "21008_1 - Event Management (applicable from AY 20-21)",
	"21008": "21008 - Other services n.e.c.",
	"22001":
		"22001 - Extra territorial organisations and bodies (IMF, World Bank, European Commission etc.)"
};
// Business code used inside business and professional incomes section
export const ProfessionalIncomeBusinessCode44ADA: { [key: string]: string } = {
	"14001": "14001 - Software development",
	"14002": "14002 - Other software consultancy",
	"14003": "14003 - Data processing",
	"14004": "14004 - Database activities and distribution of electronic content",
	"14005": "14005 - Other IT enabled services",
	"14006": "14006 - BPO services",
	"14008": "14008 - Maintenance and repair of office, accounting and computing machinery",
	"16001": "16001 - Legal profession",
	"16002": "16002 - Accounting, book-keeping and auditing profession",
	"16003": "16003 - Tax consultancy",
	"16004": "16004 - Architectural profession",
	"16005": "16005 - Engineering and technical consultancy",
	"16007": "16007 - Fashion designing",
	"16008": "16008 - Interior decoration",
	"16009": "16009 - Photography",
	"16013": "16013 - Business and management consultancy activities",
	"16018": "16018 - Secretarial activities",
	"16020": "16020 - Film Artist (applicable from AY 20-21)",
	"16019_1": "16019_1 - Medical Profession (applicable from AY 20-21)",
	"18001": "18001 - General hospitals",
	"18002": "18002 - Speciality and super speciality hospitals",
	"18003": "18003 - Nursing homes",
	"18004": "18004 - Diagnostic centres",
	"18005": "18005 - Pathological laboratories",
	"18010": "18010 - Medical clinics",
	"18011": "18011 - Dental practice",
	"18012": "18012 - Ayurveda practice",
	"18013": "18013 - Unani practice",
	"18014": "18014 - Homeopathy practice",
	"18015": "18015 - Nurses, physiotherapists or other para-medical practitioners",
	"18016": "18016 - Veterinary hospitals and practice",
	"18017": "18017 - Medical education",
	"18018": "18018 - Medical research",
	"18019": "18019 - Practice of alternative medicine",
	"18020": "18020 - Other healthcare services",
	"20010": "20010 - Individual artists excluding authors",
	"20011": "20011 - Literary activities",
	"20012": "20012 - Other cultural activities n.e.c."
};

// used in filing return info
export const RegimeTypeOptions: { [key: string]: string } = {
	"NEW_TAX_REGIME": "New tax regime",
	"OLD_TAX_REGIME": "Old tax regime"
};

export enum RegimeTypes {
	"NEW_TAX_REGIME" = "NEW_TAX_REGIME",
	"OLD_TAX_REGIME" = "OLD_TAX_REGIME"
}

export const FilingReturnFiledOptions = [
	"On or before due date - 139(1)",
	"After due date - 139(4)",
	"Revised return - 139(5)",
	"Modified return - 92CD",
	"After condonation of return - 119(2)(b)",
	"Updated return - 139(8A)"
];

export const FilingReturnInfoNoticeOptions = ["139(9)", "142(1)", "148", "153C"];

export const PersonalInfoField = [
	"DOB",
	"FatherName",
	"MobileNo",
	"EmailAddress",
	"PAN",
	"AadhaarCardNo",
	"AadhaarEnrolmentId",
	"FirstName",
	"MiddleName",
	"SurNameOrOrgName",
	"DOB",
	"DOCommencement",
	"FatherName",
	"Gender",
	"MaritalStatus",
	"Status",
	"CountryCodeMobile",
	"CountryCodeMobileNoSec",
	"MobileNoSec",
	"EmailAddressSec",
	"STDCodeLandlineNumber",
	"LandlineNumber"
];

export const AddressAndResidentialField = [
	"Address",
	"NRIJurisdictionDetails",
	"NRIStayInIndia1",
	"NRIStayInIndia2"
];
// export const AddressAndResidentialField = [
//   "Address.ResidenceNo",
//   "Address.ResidenceName",
//   "Address.RoadOrStreet",
//   "Address.LocalityOrArea",
//   "Address.PinCode",
//   "Address.ZipCode",
//   "Address.CountryCode",
//   "Address.StateCode",
//   "Address.CityOrTownOrDistrict",
//   "Address.ResidentialStatus",
//   "NRIJurisdictionDetails"
// ];

export const MaximumLimits = {
	"Section80C": 150000,
	"Section80CCC": 150000,
	"Section80TTA": 10000,
	"Section80EEB": 150000,
	"Section80EE": 50000,
	"Section80EEA": 150000,
	"Section80DD": 125000,
	"Section80U40Per": 75000,
	"Section80U80Per": 125000,
	"Section80DD40Per": 75000,
	"Section80DD80Per": 125000,
	"ProfTax16iii": 5000,
	"Section80DSenior": 50000,
	"Section80DNonSenior": 25000
};

export const DeductionSummaries: { [key: string]: string } = {
	"Section80C": "80C",
	"Section80CCC": "80CCC",
	"Section80CCDEmployeeOrSE": "80CCD(1) and 80CCD(1B)",
	"Section80CCDEmployer": "80CCD(2)",
	"Section80CCE": "80CCE",
	"Section80CCF": "80CCF",
	"Section80CCG": "80CCG",
	"Section80CCH": "80CCH",
	"Section80D": "80D",
	"Section80DD": "80DD",
	"Section80DDB": "80DDB",
	"Section80E": "80E",
	"Section80EE": "80EE",
	"Section80EEA": "80EEA",
	"Section80EEB": "80EEB",
	"Section80G": "80G",
	"Section80GG": "80GG",
	"Section80GGA": "80GGA",
	"Section80GGB": "80GGB",
	"Section80GGC": "80GGC",
	"Section80IA": "80IA",
	"Section80IB": "80IB",
	"Section80IC": "80IC",
	"Section80JJA": "80JJA",
	"Section80JJAA": "80JJAA",
	"Section80LA": "80LA",
	"Section80M": "80M",
	"Section80P": "80P",
	"Section80QQB": "80QQB",
	"Section80RRB": "80RRB",
	"Section80TTA": "80TTA",
	"Section80TTB": "80TTB",
	"Section80U": "80U"
};

// Coloumn Names you want to mention in csv file
export const UserTaxExpertCSVColsName = (data: IUserResponse[]) => {
	const fields = [
		"Id",
		"Uuid",
		"Role",
		"First Name",
		"Middle Name",
		"Last Name",
		"Full Name",
		"Phone Number",
		"Email",
		"Profile Id",
		"Profile Uuid",
		"Full Address",
		"Gender",
		"Dob",
		"Country",
		"Pincode",
		"District",
		"Registered at",
		"Updated at",
		"Last Logged In at"
	];

	const dataArray = data?.map((item) => [
		item?.id,
		item?.uuid,
		item?.role,
		item?.firstName,
		item?.middleName,
		item?.lastName,
		item?.fullName,
		item?.phoneNumber,
		item?.email,
		item?.profile?.id || "",
		item?.profile?.uuid || "",
		item?.profile?.fullAddress || "",
		item?.profile?.gender || "",
		item?.profile?.dob || "",
		item?.profile?.country || "",
		item?.profile?.pincode || "",
		item?.profile?.district || "",
		item?.createdAt,
		item?.updatedAt,
		item?.lastLoggedInAt
	]);

	return {
		fields,
		data: dataArray
	};
};

// Coloumn Names you want to mention in csv file
export const EfilingCSVColsName = (data: IFilingResponse[]) => {
	const fields = [
		"ID",
		"Created By Name",
		"Created By Email",
		"Created By Phone",
		"Assessment Year",
		"Assessee Name",
		"Assessee PAN",
		"Expert Name",
		"Updated By Name",
		"Filing Status",
		"Plan Type",
		"Plan Name",
		"Plan Amount",
		"Payment Status",
		"Created At",
		"Updated At",
		"Completed At"
	];

	const dataArray = data?.map((item) => [
		item?.id,
		item?.efilingCreatedBy?.fullName || "",
		item?.efilingCreatedBy?.email || "",
		item?.efilingCreatedBy?.phoneNumber || "",
		item?.assessmentYear,
		item?.name,
		item?.pan,
		item?.efilingAuthorizedUser?.User?.fullName || "",
		item?.efilingUpdatedBy?.fullName || "",
		"",
		capitalize(item?.efilingPlan?.planData?.type || ""),
		item?.efilingPlan?.planData?.title || "",
		item?.efilingPlan?.planData?.subtotal || "",
		item?.efilingPlan?.planData ? "Paid" : "",
		item?.createdAt,
		item?.updatedAt,
		item?.completedAt
	]);

	return {
		fields,
		data: dataArray
	};
};

export const TrackAdminFilingsStatus: { [key: string]: string } = {
	"EFILING_STATUS_CALLED": "Called",
	"EFILING_STATUS_CONVERTED": "Converted ",
	"EFILING_STATUS_NOT_CONVERTED": "Not Converted",
	"EFILING_STATUS_REQUESTED_DETAILS": "Details Requested",
	"EFILING_STATUS_RECEIVED_DETAILS": "Details Received",
	"EFILING_STATUS_FILE_UNDER_PROCESSING": "File Under Processing",
	"EFILING_STATUS_FILE_PROCESSED": "File Processed"
};

export const TrackCAFilingsStatus: { [key: string]: string } = {
	"EFILING_STATUS_REQUESTED_DETAILS": "Details Requested",
	"EFILING_STATUS_RECEIVED_DETAILS": "Details Received",
	"EFILING_STATUS_FILE_UNDER_PROCESSING": "File Under Processing ",
	"EFILING_STATUS_FILE_PROCESSED": "File Processed"
};

export const TrackEFilingStatus: { [key: string]: ITrackEFilingStatus } = {
	"CREATED": {
		label: "Created",
		variant: "greyMedium",
		bgTextColor: "secondaryLight"
	},
	"EFILING_STATUS_CALLED": {
		label: "Called",
		variant: "greyMedium",
		bgTextColor: "secondaryLight"
	},
	"EFILING_STATUS_CONVERTED": {
		label: "Converted",
		variant: "greyMedium",
		bgTextColor: "secondaryLight"
	},
	"EFILING_STATUS_NOT_CONVERTED": {
		label: "Not Converted",
		variant: "dangerLight",
		bgTextColor: "danger"
	},
	"EFILING_STATUS_REQUESTED_DETAILS": {
		label: "Details Requested",
		variant: "primaryLight",
		bgTextColor: "primaryDark"
	},
	"EFILING_STATUS_REQUESTED_DETAILS_RECEIVED": {
		label: "Details Request Received",
		variant: "primaryLight",
		bgTextColor: "primaryDark"
	},
	"EFILING_STATUS_RECEIVED_DETAILS": {
		label: "Details Received",
		variant: "warningLight",
		bgTextColor: "warning"
	},
	"EFILING_STATUS_DETAILS_SENT": {
		label: "Details Sent",
		variant: "greyLight",
		bgTextColor: "greyDark"
	},
	"EFILING_STATUS_FILE_UNDER_PROCESSING": {
		label: "File Under Processing",
		variant: "infoLight",
		bgTextColor: "info"
	},
	"EFILING_STATUS_FILE_PROCESSED": {
		label: "File Processed",
		variant: "successLight",
		bgTextColor: "success"
	}
};
